import * as R from 'ramda';
import type { SoManagerPicturePartsFragment } from '~/apollo/generated/v4/graphql';
import { PictureInitialParentType } from '~/apollo/generated/v4/graphql';
import { Heading } from '~/components/common/Heading';
import { NoItemsAlert } from '~/components/common/NoItemsAlert';
import type { PictureUploadAutofillValues } from '~/components/upload/file/picture-upload-v4';
import { SOPictureCard } from '~/components/upload/supporting-object/so-picture-card';
import { UploadPicturesModal } from '~/components/upload/supporting-object/upload-pictures-modal';
import type { RefetchQueries } from '~/utils/graphql';

export function SOPictureManager({
  parentType,
  parentId,
  pictures: picturesProp,
  refetchQueries,
  autofillValues,
}: {
  parentType: PictureInitialParentType;
  parentId: number;
  pictures: SoManagerPicturePartsFragment[];
  refetchQueries: RefetchQueries;
  autofillValues?: PictureUploadAutofillValues;
}) {
  const pictures = picturesProp
    .slice()
    .sort(R.ascend(p => p.priority ?? Infinity));

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between gap-4">
        <Heading level={3}>Pictures</Heading>
        <UploadPicturesModal
          parentType={parentType}
          parentId={parentId}
          refetchQueries={refetchQueries}
          autofillValues={autofillValues}
        />
      </div>

      <div className="space-y-2">
        {pictures.map(picture => (
          <SOPictureCard
            key={picture.id}
            picture={picture}
            refetchQueries={refetchQueries}
            studyId={
              // Provide the studyId only on the study pictures themselves;
              // this allows tagging an outcrop
              parentType === PictureInitialParentType.Study
                ? parentId
                : undefined
            }
          />
        ))}
        <NoItemsAlert show={!pictures.length} entity="pictures" />
      </div>
    </div>
  );
}
